module.exports = __webpack_public_path__ + "img/icon_m.0bbcb3ec.png";